import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'blue-button',
  templateUrl: 'blue-button.component.html',
  styleUrls: ['./blue-button.component.less', './../../common.less'],
})

export class BlueButtonComponent implements OnInit {
  @Input() buttonText: string = "";
  @Input() buttonPlus: boolean = false;
  @Input() customWidthPx: number;
  @Input() customWidthPercent: number;
  @Output() createPollEvent = new EventEmitter<boolean>();

  newPoll() {
    this.createPollEvent.emit(true)
  }

  ngAfterViewChecked() {
    if (this.customWidthPx != undefined) {
      const buttonElement = document.getElementsByClassName("blue-button")
      const button = buttonElement[0] as HTMLElement
      button.style.width = this.customWidthPx + "px"
    }
    if (this.customWidthPercent != undefined) {
      const buttonElement = document.getElementsByClassName("blue-button")
      const button = buttonElement[0] as HTMLElement
      button.style.width = this.customWidthPercent + "%"
    }
  }

  ngOnInit() {

      
  }
}
